import * as THREE from "three";
import { OBJLoader2 } from "wwobjloader2";
import { findNarrowestWaist } from './waist';
import { get_vertexpos } from "./intersection";
const SCALE_FACTOR = 100; // convert from meters to centimeters
export async function measureObj(model: { obj: string, sessionID: string, inputHeightCm?: number }) {
    const objLoader2 = new OBJLoader2();
    objLoader2.setUseIndices(true);
    const mesh: THREE.Mesh = await new Promise((resolve, reject) => {
        objLoader2.load(
            "data:model/obj;base64," + model.obj,
            function (object: THREE.Object3D) {
                object.traverse((child) => {
                    if (child instanceof THREE.Mesh || child.type === "Mesh") {
                        resolve(child as THREE.Mesh);
                    }
                });
            }
        );
    });
    if (!mesh) {
        throw new Error("Failed to load OBJ model");
    }
    // your normal‐index sets, hip bottom & waist top indices:
    const lowerMid = 1806
    const upperMid = 3079
    const headTop = 414
    const healsR = 3466
    const healsL = 6867

    const normalA = [headTop];
    const normalB = [healsR, healsL];


    const headPt = get_vertexpos(headTop, mesh.geometry);
    const heelR = get_vertexpos(healsR, mesh.geometry);
    const heelL = get_vertexpos(healsR, mesh.geometry);
    const avgHeels = heelR.clone().add(heelL).multiplyScalar(0.5);

    const headToHeels = headPt.distanceTo(avgHeels);


    // no renderer, no canvas, just pure JS:
    const { best, samples } = findNarrowestWaist(
        mesh, lowerMid, upperMid, normalA, normalB, 30
    );
    let scale = 1;
     if (model.inputHeightCm) {
        // to some issue measuring from the model directly, we apply a small fudge factor here
        const magicScale =  0.940; // adjust as needed
        console.log('best waist before scaling:', best.slice.hullLength);
        scale = model.inputHeightCm / (headToHeels * SCALE_FACTOR)*magicScale;
        console.log('model input height cm:', model.inputHeightCm, 'measured height cm:', headToHeels * SCALE_FACTOR, 'scale factor:', scale);

        //best.slice.length *= scale;
        //best.slice.hullLength *= scale;

        console.log('best waist after scaling:', best.slice.hullLength);
    }
    return {
        modelHeight: headToHeels * SCALE_FACTOR, // convert to cm
        best: best,
        samples: samples,
        scale: scale
    };
}

